import updColeccMANY from '../../../../functions/updColeccMANY';

const MainCarg = async (elementoArch, clienteSel, createMovCliCCMany, fechaHoraHoy) => {

  //ACTUALIZAR BD
  const crudBD = async (operacionCRUD, args, i)=>{
    if(args.ctrlCampo === 'CRUD'){
      const {data} = await operacionCRUD({
        variables: args
      });
      //Se utiliza para traer el _id del documento creado
      if(args.ctrl_id === 'SI_ID'){
        if(Object.values(data)[0]._id){
          return Object.values(data)[0]._id
        }else{
          return 0
        }
      }
    }else{
      if(args.ctrlCampo === "MANY"){
        await operacionCRUD({
          variables: args
        });
      }
    }
  }

  const updColecc = async (crudColecc, argsCrud, totDocCRUD)=>{
    let codigo = 0
    if(argsCrud[0].ctrl_id === 'SI_ID'){
      codigo = await crudBD(crudColecc[0], argsCrud[0], 0)
    }else{
      await crudBD(crudColecc[0], argsCrud[0], 0)
    }
    if(codigo!==0){
      for(let i=1; i<totDocCRUD; i++){
        argsCrud[i]._id = codigo
      }
    }
    for(let i=1; i<totDocCRUD; i++){
      await crudBD(crudColecc[i], argsCrud[i], i)
    }
  }

  let movCliI = []
  let argsUpd = {}
  if(elementoArch.valorIva>0){
    argsUpd = {
      "codigoImpto": "IVA",
      "descrImpto": "IVA",
      "porcImpto": elementoArch.porcIva,
      "valorImpto": elementoArch.valorIva,
    }
    movCliI.push(argsUpd)
  }
  let fechaHoy = fechaHoraHoy.substr(0, 10)
  let saldoPendiente = clienteSel.saldoPendiente
  let saldoCl = parseInt(saldoPendiente, 10) + parseInt(elementoArch.valorTotal, 10)
  argsUpd = {
    "contrato": elementoArch.contrato,
    "fechaMov": fechaHoy,
    "tipo": "C",
    "subTipo": "NC",
    "procesado": "N",
    "codigoServicio": elementoArch.concepto,
    "nombreResumido": elementoArch.concepto,
    "descripcionServicio": elementoArch.concepto,
    "concepto": elementoArch.concepto,
    "descrClaseServ": elementoArch.clase,
    "periodo": fechaHoraHoy.substr(0, 7),
    "origen": "Nuevo cargo",
    "saldoCliente": saldoCl,
    "valorTotal": parseInt(elementoArch.valorTotal, 10),
    "valorAntesImptos": parseInt(elementoArch.valorAntesDeIVA, 10),
    "agno": fechaHoraHoy.substr(0, 4),
    "mes": fechaHoraHoy.substr(5, 2),
    "valorPagado": 0,
    "numeroOdeDX": 0,
    "usuarioCreate": sessionStorage.getItem('userLogin'),
    "fechaCreate": fechaHoraHoy,
    "imptos": movCliI,
  };
  // console.log(argsUpd)

  let creaColecc = []
  creaColecc.push(argsUpd)
  let creaColeccMany = [], creaColeccMany1 = []
  creaColecc.forEach((elemento, ii) => {
    creaColeccMany.push(elemento)
  })
  creaColeccMany1.push({movcliente: creaColeccMany})
  let updColMANY = updColeccMANY(creaColeccMany1, createMovCliCCMany)
  await updColecc(updColMANY.crudColecc, updColMANY.argsCrud, updColMANY.totDocCRUD)

  const contratoFin = elementoArch.contrato
  // console.log(contrato)
  return contratoFin
}

export default MainCarg
